import { createAction } from '@reduxjs/toolkit'
import { Message } from './types';

export const sendMessage = {
  pending: createAction('friends/sendMessage/pending'),
  fulfilled: createAction<Message>('friends/sendMessage/fulfilled'),
  rejected: createAction<Error>('friends/sendMessage/rejected'),
}

export const receivedMessage = createAction<Message>('friends/receivedMessage');
export const receivedSawMessage = createAction<Message>('friends/receivedSawMessage');

export const sawMessage = {
  pending: createAction('friends/sawMessage/pending'),
  fulfilled: createAction<{ id: string, received: boolean }>('friends/sawMessage/fulfilled'),
  rejected: createAction<Error>('friends/sawMessage/rejected'),
}

// export const deleteFriend = {
//   pending: createAction('friends/deleteFriend/pending'),
//   fulfilled: createAction('friends/deleteFriend/fulfilled'),
//   rejected: createAction('friends/deleteFriend/rejected'),
// }

export const changeFriendsSort = createAction<{ value: string }>('friends/changeFriendsSort');
export const toggleShowAll = createAction('friends/toggleShowAll');
export const toggleHideFriends = createAction('friends/toggleHideFriends');
export const toggleSendTo = createAction<string>('friends/toggleSendTo');
export const readMessage = createAction<{ id: number }>('friends/readMessage');
export const deletedFriend = createAction<{ friendTo: string }>('friends/deletedFriend');
export const setHeaderPopover = createAction<string>('friends/setHeaderPopover');
export const clearNewFriends = createAction('friends/clearNewFriends');

